import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { TokenRefreshLink } from 'apollo-link-token-refresh';
import { onError } from 'apollo-link-error';
import jwtDecode from 'jwt-decode';
import { fetch } from 'whatwg-fetch';
import { getToken, setToken } from './token';
import { resolvers, typeDefs } from './resolvers';

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );

  if (networkError) {
    console.log(`[Network error]: ${networkError.message}`);
    console.log(networkError.statusCode);
    // if (networkError.statusCode == '401') {
    //   // window.location = '/login'
    //   console.log(networkError)
    // }
  }
});
const tokenRefreshLink = new TokenRefreshLink({
  accessTokenField: 'token',
  isTokenValidOrUndefined: () => {
    const token = getToken();
    if (!token) return true;

    try {
      let { exp } = jwtDecode(token);
      if (Date.now() >= exp * 1000) {
        return false;
      } else {
        return true;
      }
    } catch (e) {
      return false;
    }
  },

  fetchAccessToken: () => {
    return fetch(process.env.API_URL + 'refresh_token', {
      method: 'POST',
      credentials: 'include'
    });
  },
  handleFetch: accessToken => {
    setToken(accessToken);
  },
  handleError: err => {
    // full control over handling token fetch Error
    console.warn('Your refresh token is invalid. Try to relogin');
    console.error(err);
    setToken('');
    // user.logout()
  }
});
const httpLink = new HttpLink({
  uri: process.env.GRAPHQL_APOLLO,
  credentials: 'include',
  fetch: window.fetch || fetch
});
const httpLink2 = new HttpLink({
  uri: process.env.GRAPHQL_ENDPOINT,
  credentials: 'include',
  fetch: window.fetch || fetch
});

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  const token = getToken();
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : ''
    }
  });

  return forward(operation);
});

const cache = new InMemoryCache();

// Create the apollo client
const firstClient = new ApolloClient({
  link: ApolloLink.from([
    tokenRefreshLink,
    errorLink,
    authMiddleware,
    httpLink2
  ]),
  cache,
  resolvers
});

const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    tokenRefreshLink,
    errorLink,
    authMiddleware,
    httpLink
  ]),
  cache,
  resolvers,
  typeDefs
});

export { firstClient as graphqlClient, apolloClient };



// WEBPACK FOOTER //
// ./src/apollo.js